if (!customElements.get("custom-video")) {
  class customVideo extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector('video');
      this.playbutton = this.querySelector('.video-play-button');
      this.playing = false;


      this.handleVideoClick = () => {
        // if (customVideo.currentlyPlayingVideo && customVideo.currentlyPlayingVideo !== this) {
        //   customVideo.currentlyPlayingVideo.pauseVideo();
        // }
        if (this.playing) {
          this.pauseVideo();
        } else {
            this.playVideo();
        }
      }


      // Initialize Intersection Observer
      this.intersectionObserver = new IntersectionObserver(entries => this.handleIntersection(entries), {
        root: null,
        rootMargin: '0px',
        threshold: 0
      });

      // Add event listeners
      this.video.addEventListener('playing', () => this.handleVideoPlaying());
      this.video.addEventListener('pause', () => this.handleVideoPaused());
      if (!this.hasEventListenerAdded) {
        this.videoWrapper.addEventListener('click', this.handleVideoClick);
        this.hasEventListenerAdded = true;
      }
    }

    // static currentlyPlayingVideo = null;

    connectedCallback() {
      if (this.video && this.playbutton) {
        this.intersectionObserver.observe(this.videoWrapper);
      }
    }

    playVideo() {
      if (!this.playing) {
        this.video.play().catch(e => console.error('Error attempting to play video:', e));
        this.playing = true;
        // customVideo.currentlyPlayingVideo = this;
      }
    }

    handleVideoPlaying() {
      this.playbutton.style.display = "none";
        this.video.controls = true;
        this.videoWrapper.removeEventListener('click', this.handleVideoClick)
    }

    pauseVideo() {
      this.video.pause();
      this.playing = false;
      // customVideo.currentlyPlayingVideo = null;

    }

    handleVideoPaused() {
      this.video.controls = true;
    }

    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.intersectionRatio <= 0) {
          this.pauseVideo();
        }
      });
    }
  }

  customElements.define("custom-video", customVideo);
}
